import { createSelector } from 'reselect';

var errorSelector = function errorSelector(state) {
  return state.error;
};

export var getError = createSelector(errorSelector, function (error) {
  return error;
});